import { Dialog, DialogContent, Box, Typography, DialogActions, FormHelperText, Button, TextField, Alert } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setCompanyDetailsData } from '../../../redux/companyDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { useState } from 'react';
import '../../../css/companies/editCompany/updateCompanyName.css';

export const UpdateCompanyName = ({ openEditCompanyName, setOpenEditCompanyName }) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const [errMsg, setErrMsg] = useState('');
    const companyDetailsData = useSelector((state) => state.CompanyDetailsData);

    const formik = useFormik({
        initialValues: {
            name: companyDetailsData?.name || '',
        },

        validationSchema: Yup.object().shape({
            name: Yup.string().required(t('isRequired')),
        }),

        onSubmit: async (values) => {
            try {
                const response = await axios.patch(`company/${id}`, values);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({ open: true, type: "Nom de l’entreprise modifié avec succès" }));
                    dispatch(setCompanyDetailsData({ ...companyDetailsData, name: response.data.name }));
                    setOpenEditCompanyName(false);
                }
            } catch (error) {
                setErrMsg(error?.response?.data?.message || error.message || 'Erreur lors de la modification du nom de l’entreprise');
                console.error('Erreur lors de la modification du nom de l’entreprise :', error);
                CustomErrorLogger(error, 'Échec de la mise à jour du nom dans UpdateCompanyName');
            }
        },
    });

    const { handleSubmit, values, handleChange, handleBlur, touched, errors } = formik;

    return (
        <Dialog open={openEditCompanyName} fullWidth>
            <Box onClick={() => setOpenEditCompanyName(false)} className='updateCompanyName_icon_text'>
                <Typography className='updateCompanyName_title'>Modifier le nom de l’entreprise</Typography>
                <Iconify icon="material-symbols:close" className='updateCompanyName_close_icon' />
            </Box>
            {errMsg && <Alert key={errMsg} severity="error">{errMsg}</Alert>}
            <form onSubmit={handleSubmit}>
                <DialogContent className='updateCompanyName_dialog_content' >
                    <Box className="updateCompanyName_helper_input_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateCompanyNameInputTitle">Nom de l’entreprise</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.name}
                            className='updateCompanyName_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="name"
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='updateCompanyName_dialog_actions'>
                    <Button className='updateCompanyName_button_annuler' onClick={() => setOpenEditCompanyName(false)}>{t('Annuler')}</Button>
                    <Button className='updateCompanyName_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};